/** 
 * Base commune à tous les types Data
 * Chaque DataBlock peut spécialiser cette classe pour créer son propre bloc de données géré via la classe FeatureConfigWData
 **/
export default class BaseData {
	Id: number;
}